import { render, staticRenderFns } from "./MassenmutationModalNeu.vue?vue&type=template&id=c48bb414"
import script from "./MassenmutationModalNeu.vue?vue&type=script&lang=js"
export * from "./MassenmutationModalNeu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports